import type { SpecialtyAttribute } from '../services/videoApi/videoApi.types';

/**
 * キー付きタグを持つ動画の最小形。表示・検索・編集はすべてこのタグを読む。
 */
export interface VideoWithSpecialtyAttributes {
  specialty_attributes?: SpecialtyAttribute[] | null;
}

const UNSET = '未設定';

const isPresent = (value: string | null | undefined): value is string =>
  typeof value === 'string' && value.trim() !== '' && value !== UNSET;

/**
 * 表示・編集に使うキー付きタグを返す。キーか値が空・「未設定」の行は落とす。
 */
export const resolveSpecialtyAttributes = (video: VideoWithSpecialtyAttributes): SpecialtyAttribute[] =>
  (video.specialty_attributes ?? []).filter(
    attribute => isPresent(attribute.attribute_key) && isPresent(attribute.attribute_value)
  );

/**
 * 検索欄に入れる `キー:値` の形にする
 */
export const toSearchQuery = (attribute: SpecialtyAttribute): string =>
  `${attribute.attribute_key}:${attribute.attribute_value}`;

/**
 * `部位:膝` のような検索トークンをキーと値に分解する。バックエンドの parseAttributeToken と同じ規則。
 * 先頭が数字（10:30 の時刻）や値が / で始まるもの（URL）は対象外。
 */
export const parseAttributeToken = (token: string): SpecialtyAttribute | null => {
  const separatorIndex = token.indexOf(':');
  if (separatorIndex <= 0 || separatorIndex === token.length - 1) return null;

  const key = token.slice(0, separatorIndex).trim();
  const value = token.slice(separatorIndex + 1).trim();
  if (!key || !value) return null;
  if (/^\d/.test(key)) return null;
  if (value.startsWith('/')) return null;

  return { attribute_key: key, attribute_value: value };
};
